console.log('page.careers.js');

const options = { method: 'GET', headers: {Accept: 'application/json'}};

// fetch('http://localhost:3000/dev/jobs')
//   .then(response => response.json())
//   .then(response => {
//     console.log('response => ', response);

//     document.querySelector('.careers_Department').innerHTML = `
//       <option value="default">Filter by Department</option>
//       ${response.departments.map(department => `
//         <option value="${department.id}">${department.name}</option>
//       `)}
//     `
//   });


  //Nathans code 11-12-22

function generate_job_list(job) {
  
    var job_title = job.title;
    var job_city = job.city;
    var job_state = job.state;
    var job_country = job.country;
    var employment_time = job.employment_type.replace('-',' ');
    var department_type = job.department;
    var description = job.description;
    var application_url = job.application_url;
    var job_title = '<div class="job_title" >' + '<h2>'+ job_title +'</h2>'+'</div>';
    var address = '<div class="address">'+ '<span class="city">' + job_city +', '+ job_state +' '+ job_country +'</span>' + "</div>";
    var employment_type = '<span class="employment_type">'+ employment_time +"</span>";
    var department ='<span class="department">'+ department_type +"</span>";
    var data = '<li class="content_list">' + job_title + address + department  + employment_type  + '<div class="job_description hidden">'+ '<h4 class="heading">Description</h4>' + description + '<a class="application_btn" href="'+ application_url +'">Apply for this job</a>'+ '</div>' + '</li>';
      $('#content').append(data);
      
}

  function set_job_dom_content(jobs) {
    
    
    $('#content').html('');
    for (let index = 0; index < jobs.length; index++) {
      var job = jobs[index];
      generate_job_list(job);
    }
  }

  function set_job_filters(jobs)  {

    var country_options = [];
    var department_options = [];
    var worktype_options = [];

    for (let index = 0; index < jobs.length; index++) 
    {
      var job = jobs[index];
      var location = job.city +', '+ job.state +', '+ job.country;
      country_options.push(location);
      department_options.push( job.department);
      worktype_options.push(job.employment_type.replace('-',' '));
      if ( index == jobs.length - 1) 
      {
          // set location
          const unique = arr => [...new Set(arr)];
          country_options = unique(country_options);
          department_options = unique(department_options);
          worktype_options = unique(worktype_options);
          generate_filter_option(country_options,'.location');
          generate_filter_option(department_options, '.careers_Department');
          generate_filter_option(worktype_options, '.work_type');           
      }
    }
   
  }
  function generate_filter_option(filter_values,selector) 
  {

    for (let index = 0; index < filter_values.length; index++) {
      var filter = filter_values[index];
      var filter_option = '<option value="'+ filter +'">' +filter+ '</option>';
      $(selector).append(filter_option);
    }  
  }

  function filter_jobs(all_jobs) 
  {


    var search_filter_value = $(".careers__Controls input:text").val().toLowerCase();
    var select_location_value = $( ".wraper .location option:selected" ).val().toLowerCase();
    var select_department_value = $( ".wraper .careers_Department option:selected" ).val().toLowerCase();
    var select_work_type_value = $( ".wraper .work_type option:selected" ).val().toLowerCase();

    if (search_filter_value != '') 
    {
      all_jobs = all_jobs.filter((job) => {
        if(job.title.toLowerCase().indexOf(search_filter_value) != -1)
        {
          return job;
        }
      });
    }
    
    if ( select_location_value != '') {
      all_jobs = all_jobs.filter((job) => {
        var location = job.city +', '+ job.state +', '+ job.country;
        if(location.toLowerCase()== select_location_value)
        {
          return job;
        }
      });
    }

    if ( select_department_value != '') {
      all_jobs = all_jobs.filter((job) => {
        
        if(job.department.toLowerCase()== select_department_value)
        {
          return job;
        }
      });
    }

    if ( select_work_type_value != '') {
      all_jobs = all_jobs.filter((job) => {
        var employment_type = job.employment_type.replace('-',' ');
        console.log(employment_type,"=",select_work_type_value);

        if(employment_type.toLowerCase()== select_work_type_value)
        {
          return job;
        }
      });
      console.log('all_jobs',all_jobs);
    }
    
    
    $('#content').html('');
    if (all_jobs.length == 0) {
      $('#content').html('<h3 class= "error_message"> Sorry, no job found matching these criteria.</h3>');
      
    }else
    {

      for (let index = 0; index < all_jobs.length; index++) 
      {
        var single_job = all_jobs[index];
        generate_job_list(single_job);
      }
    }
  }

window.addEventListener( "load", function()
{
    var all_jobs = [];
    SendAPIRequest( "https://apply.workable.com/api/v1/widget/accounts/arne?details=true", "GET", {}, [], function( err, xhr )
      {
        var job_details =  JSON.stringify( xhr ); 
        all_jobs = xhr.jobs;
        set_job_dom_content(xhr.jobs);
        set_job_filters(xhr.jobs );
    
        $(document).on('click','.content_list',function () {
          $(this).find('.job_description').toggleClass('hidden');
        })

    } )
    $(document).on('keyup','.careers__Search',function () {      
      if ($(this).val().length >= 3)
      {
        filter_jobs(all_jobs);  
      }
      else if($(this).val() == "")
      {

        set_job_dom_content(all_jobs);
      }
    })
    $(document).on('change','.wraper select',function () {  
      filter_jobs(all_jobs);     
    });
} );